export default __webpack_public_path__ + "static/media/tt-hoves-demibold.707c7343.woff";